export const truncateText = (cutPoint: number, text: string): string =>
    text.length > cutPoint ? `${text.slice(0, cutPoint)}...` : text;
